import React from 'react'
import CheckBox from './check-box'
import { get } from 'lodash'
import USER_ROLES from '../../../constants/user-roles'

const RolesSelector = ({
    value = {},
    onChange = () => {},
}) => {
    const roleCodes = get(value, 'rolesCode', 's')
    const updateRole = (key, enabled) => {
        const rolesCode = roleCodes.replace(key, '') + (enabled ? key : '')
        onChange({ ...value, rolesCode })
    }

    return (
        <React.Fragment>
            <CheckBox
                label='Student'
                checked={roleCodes.includes(USER_ROLES.STUDENT)}
                onChange={checked => updateRole(USER_ROLES.STUDENT, checked)}
            />
            <CheckBox
                label='TSC'
                checked={roleCodes.includes(USER_ROLES.TSC)}
                onChange={checked => updateRole(USER_ROLES.TSC, checked)}
            />
            <CheckBox
                label='Facilitator / Mentor'
                checked={roleCodes.includes(USER_ROLES.FACILITATOR)}
                onChange={checked => updateRole(USER_ROLES.FACILITATOR, checked)}
            />
            <CheckBox
                label='Administrator'
                checked={roleCodes.includes(USER_ROLES.ADMIN)}
                onChange={checked => updateRole(USER_ROLES.ADMIN, checked)}
            />
        </React.Fragment>
    )
}

export default RolesSelector